import { AmbassadorSettingsConfig } from "@energylab/shared-components/constants/config/ambassadorConfig";

export const ambassadorSettingsConfig: AmbassadorSettingsConfig = {
    enableRelive: true
};
